import { render, staticRenderFns } from "./ReceptionsForDriving.vue?vue&type=template&id=13a1f30f"
import script from "./ReceptionsForDriving.vue?vue&type=script&lang=js"
export * from "./ReceptionsForDriving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports